module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_heart-9e074e0b6c9c71b1a37a527d3fdb973e.png";